export class RepReportPersonEntity{
    id:number;
    reportId:number;
    personId:number;

    constructor(){}
}